import React, { Component } from 'react';
import { Wrapper, Field, Register, Button, Label, Input } from './styles';
import store from '../../store';
import ReactDOM from 'react-dom';
import * as securityActions from '../../actions/Security/actions';

export class Password extends Component {
	constructor() {
		super();
		this.state = {
			hasPassword: false,
		};
		this.passwordDomElement = null;
	}

	getPasswordDomElement = () => {
		if (!this.passwordDomElement) {
			this.passwordDomElement = ReactDOM.findDOMNode(this.passwordComponent);
		}
		return this.passwordDomElement;
	};

	changeHandler = event => {
		const passwordDomElement = this.getPasswordDomElement();
		const hasPassword = passwordDomElement.value.length > 0;

		if (hasPassword !== this.state.hasPassword) {
			this.setState({ hasPassword });
		}
	};

	submitHandler = event => {
		const passwordDomElement = this.getPasswordDomElement();
		const isCorrectPassword = passwordDomElement.value === 'sunglow';
		store.dispatch(securityActions.passwordEntered(isCorrectPassword));
		if (isCorrectPassword){
			this.props.history.push('/app');
		}
	};

	render() {
		const { hasPassword } = this.state;
		return (
			<Wrapper>
				<Register>
					<Field>
						<Input
							id="pw-input"
							type="password"
							maxLength="21"
							onChange={this.changeHandler}
							ref={component => {
								this.passwordComponent = component;
							}}
						/>
						<Label for="pw-input">
							<span>Password</span>
						</Label>
						<Button active={hasPassword} onClick={this.submitHandler} type="submit">
							Submit
						</Button>
					</Field>
				</Register>
			</Wrapper>
		);
	}
}

export default Password;



// WEBPACK FOOTER //
// ./src/containers/Password/index.js